module.exports = __webpack_public_path__ + "static/img/lotus.b4d17d4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lotus.svg
// module id = CViL
// module chunks = 0